import { TStatus } from "../../mock";
import { TExportStatus } from "../mock";

export type TExportHistoryStatus =
  | "exportação criada"
  | "em processamento"
  | "erro ao processar"
  | "processamento completo"
  | "exportação finalizada";

export type TExportHistoryItem = {
  status: TExportHistoryStatus;
  created_at: string;
  created_by: string;
};

export type TNature =
  | "001 - Compra"
  | "002 - Venda"
  | "003 - Transferência"
  | "004 - Devolução"
  | "005 - Importação"
  | "006 - Exportação"
  | "007 - Remessa"
  | "008 - Retorno"
  | "009 - Outras entradas"
  | "010 - Outras saídas"
  | "011 - Serviços - ISSQN"
  | "012 - Lançamento de Crédito"
  | "013 - Recebimento"
  | "014 - Ressarcimento"
  | "015 - Serviço - ICMS";

export type TIssuedExportedInvoice = {
  start_date?: string;
  end_date?: string;
  status?: TStatus[];
  nature?: TNature[];
};

export const mockExportedInvoice: TIssuedExportedInvoice = {
  start_date: "2025-10-01",
  end_date: "2025-10-10",
  status: ["Autorizada", "Em processamento"],
  nature: ["002 - Venda", "001 - Compra"],
};

export const exportIssuedInvoiceMock = {
  count: 12,
  current_page: 1,
  pages: [{ "1": "" }],
  results: [
    {
      id: "001",
      start_date: "2025-09-01",
      end_date: "2025-09-30",
      created_at: "2025-10-01T08:00:00.000Z",
      created_by: "João da Silva",
      export_status: "Finalizada" as TExportStatus,
      status: ["Em processamento"] as TStatus[],
      uuid: "a1b2c3d4-e5f6-7890-ab12-cd34ef56ab78",
      xml_url: "https://example.com/xml/001",
      pdf_url: "https://example.com/pdf/001",
      history: [
        {
          status: "exportação finalizada" as TExportHistoryStatus,
          created_at: "2025-09-30T10:00:00.000Z",
          created_by: "Equipe Fiscal",
        },
        {
          status: "em processamento" as TExportHistoryStatus,
          created_at: "2025-09-30T08:00:00.000Z",
          created_by: "João da Silva",
        },
        {
          status: "exportação criada" as TExportHistoryStatus,
          created_at: "2025-09-30T07:00:00.000Z",
          created_by: "João da Silva",
        },
      ],
      nature: ["002 - Venda"] as TNature[], // One nature
    },
    {
      id: "002",
      start_date: "2025-08-01",
      end_date: "2025-08-31",
      created_at: "2025-09-01T09:30:00.000Z",
      created_by: "Maria Oliveira",
      export_status: "Erro ao processar" as TExportStatus,
      status: [
        "Em processamento",
        "Autorizada",
        "Autorizada em contingência",
        "Rejeitada",
        "Denegada",
        "Cancelada",
        "Inutilizada",
      ] as TStatus[],
      uuid: "b2c3d4e5-f678-9012-ab34-cd56ef78ab90",
      xml_url: "https://example.com/xml/002",
      pdf_url: "",
      history: [
        {
          status: "erro ao processar" as TExportHistoryStatus,
          created_at: "2025-08-31T09:00:00.000Z",
          created_by: "Equipe Fiscal",
        },
        {
          status: "em processamento" as TExportHistoryStatus,
          created_at: "2025-08-31T08:00:00.000Z",
          created_by: "Maria Oliveira",
        },
        {
          status: "exportação criada" as TExportHistoryStatus,
          created_at: "2025-08-31T07:00:00.000Z",
          created_by: "Maria Oliveira",
        },
      ],
      nature: [
        "001 - Compra",
        "002 - Venda",
        "003 - Transferência",
        "004 - Devolução",
        "005 - Importação",
        "006 - Exportação",
        "007 - Remessa",
        "008 - Retorno",
        "009 - Outras entradas",
        "010 - Outras saídas",
        "011 - Serviços - ISSQN",
        "012 - Lançamento de Crédito",
        "013 - Recebimento",
        "014 - Ressarcimento",
        "015 - Serviço - ICMS",
      ] as TNature[], // All natures
    },
    {
      id: "003",
      start_date: "2025-07-01",
      end_date: "2025-07-31",
      created_at: "2025-08-01T10:15:00.000Z",
      created_by: "Carlos Souza",
      export_status: "Em processamento" as TExportStatus,
      status: ["Em processamento", "Autorizada", "Cancelada"] as TStatus[],
      uuid: "c3d4e5f6-7890-1234-ab56-cd78ef90ab12",
      xml_url: "",
      pdf_url: "https://example.com/pdf/003",
      history: [
        {
          status: "processamento completo" as TExportHistoryStatus,
          created_at: "2025-09-30T09:00:00.000Z",
          created_by: "Equipe Fiscal",
        },
        {
          status: "em processamento" as TExportHistoryStatus,
          created_at: "2025-07-31T08:00:00.000Z",
          created_by: "Carlos Souza",
        },
        {
          status: "exportação criada" as TExportHistoryStatus,
          created_at: "2025-07-31T07:00:00.000Z",
          created_by: "Carlos Souza",
        },
      ],
      nature: ["002 - Venda", "005 - Importação", "007 - Remessa"] as TNature[], // Something in the middle
    },
  ],
};

export type TIssuedInvoiceExport = (typeof exportIssuedInvoiceMock.results)[0];
